__turbopack_context__.v({
  "drawer": "NotificationDrawer-module-scss-module__rTOz9q__drawer",
  "empty": "NotificationDrawer-module-scss-module__rTOz9q__empty",
  "list": "NotificationDrawer-module-scss-module__rTOz9q__list",
  "listInner": "NotificationDrawer-module-scss-module__rTOz9q__listInner",
});
